module.exports = __webpack_public_path__ + "img/nebraska-methodistchurch.26d867a7.png";